import { useFlags } from '@mint-lib/routing-context';

const useOmniConnectorFlags = () => {
  const ff = useFlags('@mint/arm', [
    'omniConnectorCriteo',
    'omniConnectorTradeDesk',
    'omniConnectorXads',
  ]);

  return {
    criteo_integrated: ff?.omniConnectorCriteo?.enabled,
    trade_desk_integrated: ff?.omniConnectorTradeDesk?.enabled,
    x_ads_integrated: ff?.omniConnectorXads?.enabled,
  } as { [key: string]: boolean };
};

export default useOmniConnectorFlags;
